import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const REQUIRED_ENV_VARS = [
  'REACT_APP_SUPABASE_URL',
  'REACT_APP_SUPABASE_ANON_KEY',
];

const missingEnvVars = REQUIRED_ENV_VARS.filter((v) => !process.env[v]);
const isSupabaseConfigured = missingEnvVars.length === 0;

function SupabaseSetupGuide() {
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#0a0a0f',
      color: '#e2e8f0',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      padding: '1.5rem',
    }}>
      <div style={{
        maxWidth: '600px',
        width: '100%',
        padding: '2.5rem',
        borderRadius: '1rem',
        border: '1px solid #1e293b',
        background: 'linear-gradient(135deg, #0f172a 0%, #0a0a0f 100%)',
        boxShadow: '0 0 40px rgba(0,102,255,0.08)',
      }}>
        <div style={{ fontSize: '2.5rem', marginBottom: '0.5rem' }}>⚙️</div>
        <h1 style={{ fontSize: '1.5rem', fontWeight: 700, margin: '0 0 0.5rem' }}>
          Supabase Setup Required
        </h1>
        <p style={{ color: '#94a3b8', fontSize: '0.9rem', lineHeight: 1.6, margin: '0 0 1.5rem' }}>
          Create a <code style={{
            background: '#1e293b', padding: '2px 6px', borderRadius: '4px', fontSize: '0.85em'
          }}>.env</code> file in the project root with the following variables:
        </p>
        <div style={{
          background: '#020617',
          borderRadius: '0.5rem',
          padding: '1rem 1.25rem',
          fontFamily: 'monospace',
          fontSize: '0.8rem',
          lineHeight: 1.8,
          overflowX: 'auto',
          border: '1px solid #1e293b',
        }}>
          {missingEnvVars.map((v) => (
            <div key={v}>
              <span style={{ color: '#f97316' }}>{v}</span>
              <span style={{ color: '#475569' }}>=your_value_here</span>
            </div>
          ))}
        </div>
        <p style={{ color: '#64748b', fontSize: '0.8rem', marginTop: '1.25rem', lineHeight: 1.6 }}>
          You can find these values in your{' '}
          <a href="https://supabase.com/dashboard" target="_blank" rel="noopener noreferrer"
            style={{ color: '#38bdf8', textDecoration: 'none' }}>
            Supabase Dashboard
          </a>{' '}
          → Project Settings → API. After adding the file, restart the dev server.
        </p>
      </div>
    </div>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
  <React.StrictMode>
    {isSupabaseConfigured ? (
      <BrowserRouter>
        <ThemeProvider>
          <AuthProvider>
            <App />
          </AuthProvider>
        </ThemeProvider>
      </BrowserRouter>
    ) : (
      <SupabaseSetupGuide />
    )}
  </React.StrictMode>
);

reportWebVitals();
